import { LeadStatus } from "@/entities/lead-v2/model";

export const PAGE_SIZE = 10;
export const SMALL_PAGE_SIZE = 5;

const timeFields = {
  lastDepositDate: "Последний депозит",
  updated: "Изменен",
  lastChange: "Изменен",
  lastCall: "Последний звонок",
  created: "Создано",
  requestDate: "Дата запроса",
  callDate: "Дата прозвона",
  startOfTraining: "Начало тренировки",
  lastOnline: "Зашел",
  createdAt: "Зашел",
  date: "Дата",
  updatedAt: "Изменен",
};

const statsFields = {
  redepositsCount: "Количество депозитов",
  totalProfit: "Заработок",
  totalIncome: "Заработок",
  totalTurnover: "Оборот",
  grossIncome: "Грязная прибыль",
  netIncome: "Чистая прибыль",
  curatorsCount: "Кол-во аккаунтов",
  leadsCount: "Количество лидов",
  earnings: "Прибыль",
  balance: "Баланс",
  profit: "Прибыль",
  "usdtBalance.balance": "Баланс",
  earningsUntilRelease: "Зароботок с ученика",
  activeStudentsCount: "Активных учеников",
  graduatedStudentsCount: "Выпустившихся учеников",
  totalLeadsCount: "Лидов",
  depositsCount: "Кол-во Депов",
  closedLeadsCount: "Кол-во закрытий",
};

const userFields = {
  tgUsername: "Телеграм",
  tgNickname: "Имя",
  nickname: "Никнейм",
  username: "Никнейм",
  "userId.username": "Никнейм",
  name: "Имя",
};

const roleFields = {
  manager: "Менеджер",
  curator: "Куратор",
  teamlead: "Тимлид",
  head: "Руководитель",
  worker: "Воркер",
  master_teamlead: "Мастерлид",
};

const leadStatusFields: Record<LeadStatus, string> = {
  [LeadStatus.SPINNING]: "Крутит",
  [LeadStatus.IGNORE]: "Игнорит",
  [LeadStatus.REJECTED]: "Отклонен",
  [LeadStatus.HAD_CALL]: "Был звонок",
  [LeadStatus.TEXTED]: "Отписал",
  [LeadStatus.LOOKING_FOR_DEPOSIT]: "В поисках депозита",
  [LeadStatus.SURVEY_COMPLETED]: "Прошёл опрос",
  [LeadStatus.FRESH]: "Новый",
  [LeadStatus.DEPOSIT]: "Дэп",
  [LeadStatus.REMOVED_BY_SURVEY]: "Удалён",
  [LeadStatus.WARMING_UP]: "Греется",
  [LeadStatus.SURVEY_IN_PROGRESS]: "Опрос в процессе",
  [LeadStatus.UNLINKED]: "Отвязан",
  [LeadStatus.MANUAL_DEPOSIT]: "Ручной депозит",
};

const statusFields = {
  status: "Статус",
  confirmed: "Завершено",
  declined: "Отменено",
  had_call: "Был звонок",
  spinning: "Крутит",
  rejected: "Отклонен",
  survey_completed: "Прошел опрос",
  completed: "Завершенo",
  survey_in_progress: "Проходит опрос (в процессе)",
  removed_by_survey: "Опрос не пройден",
  waiting_for_complete: "Ожидает завершения",
  closed_after_dispute: "Закрыт после спора",
  texted: "Отписал",
  in_progress: "В процессе",
  dispute: "Спор",
  deposit: "Деп",
  pending: "В ожидании",
  approved: "Одобрено",
  looking_for_deposit: "В поиске депозита",
  active: "Активный",
  accepted: "Принят",
  archived: "Архив",
  inactive: "Неактивный",
  alive: "Жив",
  warming_up: "Прогрев",
  dead: "Мертв",
  banned: "Забанен",
  "invalid login or password": "Неверный логин или пароль",
  milestone: "Юбилейный",
  pair: "Парная",
  personal: "Личная",
  BANNED: "Заблокирован",
  KEPT: "Оставлен",
  OUTDATED: "Устарел",
  outdated: "Устарел",
  ignore: "Игнорит",
  fresh: "Не прошел опрос",
  stopped: "Остановлен",
  deleted: "Удален",
};

const miscFields = {
  type: "Тип",
  link: "Ссылка",
  asc: "По возрастанию",
  desc: "По убыванию",
  verdict: "Решение",
};

const reasonFields = {
  clan_member: "Участник клана",
  other: "Другое",
};

const ratingFields = {
  one: "1",
  two: "2",
  three: "3",
  four: "4",
  five: "5",
  six: "6",
  seven: "7",
  eight: "8",
  nine: "9",
  ten: "10",
};

export const localizationMap: Record<string, string> = {
  ...timeFields,
  ...statsFields,
  ...userFields,
  ...roleFields,
  ...statusFields,
  ...leadStatusFields,
  ...miscFields,
  ...reasonFields,
  ...ratingFields,
};
